import { Component, EventEmitter, Input, Output } from '@angular/core';

import { EpcotConfig } from '@frontend/sports/common/client-config-data-access';

import { IFilterConstraint } from '../../models/my-bets-filter-constraints';

@Component({
    selector: 'ms-my-bets-filter-constraint-button',
    template: `
        <div class="my-bets-filter-constraint-button highlight" (click)="onConstraintRemove()">
            <div class="my-bets-filter-constraint-button_title">{{ constraint.title }}</div>
            <div class="my-bets-filter-constraint-button_remove"><vn-icon name="theme-ex" [size]="isEpcotEnabled ? '12' : '7'" /></div>
        </div>
    `,
    standalone: false,
})
export class MyBetsFilterConstraintButtonComponent {
    @Input() constraint: IFilterConstraint<any>;
    @Output() remove = new EventEmitter<IFilterConstraint<any>>();
    readonly isEpcotEnabled: boolean;

    constructor(private epcotConfig: EpcotConfig) {
        this.isEpcotEnabled = this.epcotConfig.isEnabled;
    }

    onConstraintRemove(): void {
        this.remove.emit(this.constraint);
    }
}
